<div class="details">

  <div class="row">
    <div class="col-md-6">
      <h5 class="hub-level-1-label">Core Projects</h5>

      @if (coreRelatedProjects.length || coreProposedProjects.length) {
        <div class="hub-pill-list hub-custom-scrollbar relations-list"
          >
          @for (relation of coreRelatedProjects; track trackByFn($index, relation)) {
            <span>
              <a [routerLink]="'/portfolio/' + relation.relatedProjectId"
                class="badge-primary badge font-size-lg mr-1 mb-1">
                <i class="icon-loop3 mr-2"
                [ngClass]="{'d-none' : !isVerified(relation, backwardRelations, true)}"></i>{{relation.relatedProject?.name}}
              </a>
            </span>
          }
          @for (relation of coreProposedProjects; track trackByFn($index, relation)) {
            <span class="proposed-relation">
              <a [routerLink]="'/portfolio/' + relation.projectId"
                class="badge-primary badge font-size-lg mr-1 mb-1" tooltip="This relation is not confirmed"
                placement="top">
                {{relation.project?.name}}
              </a>
            </span>
          }
        </div>
      }

      @if (!coreRelatedProjects.length && !coreProposedProjects.length) {
        <div class="no-relations-warning">
          This strategy does not have any confirmed core relations to projects.
        </div>
      }


      <h5 class="hub-level-1-label">Additional Projects</h5>

      @if (additionalRelatedProjects.length || additionalProposedProjects.length) {
        <div class="hub-pill-list hub-custom-scrollbar relations-list"
          >
          @for (relation of additionalRelatedProjects; track trackByFn($index, relation)) {
            <span>
              <a [routerLink]="'/portfolio/' + relation.relatedProject?.projectId"
                class="badge-primary badge font-size-lg mr-1 mb-1">
                <i class="icon-loop3 mr-2"
                [ngClass]="{'d-none' : !isVerified(relation, backwardRelations, false)}"></i>{{relation.relatedProject?.name}}
              </a>
            </span>
          }
          @for (relation of additionalProposedProjects; track trackByFn($index, relation)) {
            <span
              class="proposed-relation">
              <a [routerLink]="'/portfolio/' + relation.project?.projectId"
                class="badge-primary badge font-size-lg mr-1 mb-1" tooltip="This relation is not confirmed"
                placement="top">
                {{relation.project?.name}}
              </a>
            </span>
          }
        </div>
      }

      @if (!additionalRelatedProjects.length && !additionalProposedProjects.length) {
        <div class="no-relations-warning"
          >
          This strategy does not have any confirmed additional relations to projects.
        </div>
      }

      @if (relations.length) {
        <div class="mt-1 text-muted font-size-sm">
          <i class="icon-loop3 mr-1 ml-1 text-muted round-rounded"></i> indicates a reciprocal relationship
          between Project and Strategy
        </div>
      }

    </div>

    <div class="col-md-6">

      <h5 class="hub-level-1-label">Region(s)</h5>

      <ul class="hub-bulleted-list">
        @for (regionName of regionNames; track regionName) {
          <li>
            {{ regionName }}
          </li>
        }
      </ul>

      <h5 class="hub-level-1-label">Division(s)</h5>

      <ul class="hub-bulleted-list">
        @for (divisionName of divisionNames; track divisionName) {
          <li>
            {{ divisionName }}
          </li>
        }
      </ul>

      <h5 class="hub-level-1-label">Business Unit(s)</h5>

      <div class="hub-pill-list">
        @for (bu of projectBusinessUnits; track bu) {
          <span>
            @if (bu.isLeadBusinessUnit) {
              <a>
                <span
                class="badge badge-info font-size-lg mr-1 mb-1">{{ bu.businessUnit.name }}</span>
              </a>
            }
            @if (!bu.isLeadBusinessUnit) {
              <a>
                <span class="badge badge-info-secondary font-size-lg mr-1 mb-1">{{ bu.businessUnit.name }}</span>
              </a>
            }
          </span>
        }
      </div>

      <h5 class="hub-level-1-label">Related Program Management</h5>

      @if (programManagementRecords) {
        <div>
          @for (pm of programManagementRecords; track pm) {
            <span>
              <a [routerLink]="'/portfolio/' + pm.projectId">
                <span class="badge badge-primary font-size-lg mr-1 mb-1">{{ pm.name }}</span>
              </a>
            </span>
          }
        </div>
      }

      @if (programManagementRecords.length === 0) {
        <div class="no-relations-warning" style="color: #999;">
          A Program Management has not identified this record as part of their portfolio.
        </div>
      }

      <h5 class="hub-level-1-label">Related Whole Systems</h5>

      @if (wholeSystemRecords) {
        <div>
          @for (ws of wholeSystemRecords; track ws) {
            <span>
              <a [routerLink]="'/portfolio/' + ws.projectId">
                <span class="badge badge-primary font-size-lg mr-1 mb-1">{{ ws.name }}</span>
              </a>
            </span>
          }
        </div>
      }

      @if (wholeSystemRecords.length === 0) {
        <div class="no-relations-warning" style="color: #999;">
          A Whole System has not identified this record as part of their portfolio.
        </div>
      }


    </div>

  </div>
